module.exports = __webpack_public_path__ + "static/img/39.974eab96.png";